<div class="table-container">
  <section class="table-section table-section--bonus">
    <div class="table-section__table">
      @if (title && isFirstSection) {
        <h1 class="table-section__title" [innerHTML]="title | translate"></h1>
      }
      @if (title && !isFirstSection) {
        <h2 class="table-section__title" [innerHTML]="title | translate"></h2>
      }
      <div
        class="table-section__description"
        [innerHTML]="description | unescape"
      ></div>
      <table
        mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z8"
        [ngClass]="{
          'bg-transparent': transparentBackground,
          'lines-transparent': transparentLines,
          'no-filter': noFilter,
        }"
      >
        @for (column of contentsHead; track column; let i = $index) {
          <ng-container [matColumnDef]="column.text">
            <th mat-header-cell *matHeaderCellDef>
              {{ column.text | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              @if (row[i]) {
                @if (column.type == "button") {
                  <span>
                    <a [href]="row[i].link">
                      <input
                        type="button"
                        class="table-section__button"
                        [value]="row[i].text | translate"
                      />
                    </a>
                  </span>
                }
                @if (column.type == "download") {
                  <span>
                    <a [href]="row[i].link" target="_blank">
                      @if (!row[i].text) {
                        <i class="far fa-file-alt"></i>
                      } @else {
                        {{ row[i].text | translate }}
                      }
                    </a>
                  </span>
                }
                @if (column.type == "func") {
                  <span>
                    <input
                      type="button"
                      class="table-section__button"
                      (click)="(row[i].func)"
                      [value]="row[i].text | translate"
                    />
                  </span>
                }
                @if (column.type == "link") {
                  <span>
                    <a class="table-section__link" [href]="row[i].link">{{
                      row[i].text | translate
                    }}</a>
                  </span>
                }
                @if (column.type == "text") {
                  <span>
                    <p
                      class="table-section__text"
                      [innerHTML]="row[i].text | unescape"
                    ></p>
                  </span>
                }
              }
            </td>
          </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </section>
</div>
